import type { LocalShiftType } from '@wolhasudang/shared';

function rgb(hex: string): [number, number, number] {
  return [1, 3, 5].map((offset) => Number.parseInt(hex.slice(offset, offset + 2), 16)) as [number, number, number];
}

function luminance(hex: string): number {
  const [red, green, blue] = rgb(hex).map((value) => {
    const channel = value / 255;
    return channel <= 0.04045 ? channel / 12.92 : ((channel + 0.055) / 1.055) ** 2.4;
  });
  return red! * 0.2126 + green! * 0.7152 + blue! * 0.0722;
}

export function contrastRatio(foreground: string, background: string): number {
  const values = [luminance(foreground), luminance(background)].sort((a, b) => b - a);
  return (values[0]! + 0.05) / (values[1]! + 0.05);
}

export function readableShiftText(background: string): '#ffffff' | '#000000' {
  return contrastRatio('#ffffff', background) >= contrastRatio('#000000', background) ? '#ffffff' : '#000000';
}

export function shiftSymbol(type: Pick<LocalShiftType, 'kind' | 'countsAsNight' | 'start'>): string {
  if (type.kind === 'off') return '○';
  if (type.kind === 'leave') return '◇';
  if (type.kind === 'absence') return '×';
  if (type.countsAsNight) return '☾';
  const hour = Number(type.start.slice(0, 2));
  return hour >= 14 ? '◐' : '☀';
}
